module.exports = __webpack_public_path__ + "static/3gde-d1188d7fff237277bbea5f551a47109a.gif";